// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Account from "./account.js"
import StripeSubscription from "./stripe-subscription.js"

const modelClassData = {
  "attributes": {
    "currency": {
      "column": {
        "default": null,
        "name": "currency",
        "null": true,
        "type": "string"
      },
      "name": "currency",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeCustomer",
  "collectionKey": "stripe_customers",
  "collectionName": "stripe_customers",
  "i18nKey": "stripe_customer",
  "camelizedLower": "stripeCustomer",
  "name": "StripeCustomer",
  "nameDasherized": "stripe-customer",
  "pluralName": "stripe_customers",
  "ransackable_associations": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "stripe_customer_id",
      "name": "account",
      "macro": "has_one",
      "resource_name": "Account",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeCard",
      "collectionName": "stripe_cards",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_cards",
      "macro": "has_many",
      "resource_name": "StripeCard",
      "through": null
    },
    {
      "className": "StripeCharge",
      "collectionName": "stripe_charges",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_charges",
      "macro": "has_many",
      "resource_name": "StripeCharge",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_discounts",
      "macro": "has_many",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeInvoiceItem",
      "collectionName": "stripe_invoice_items",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_invoice_items",
      "macro": "has_many",
      "resource_name": "StripeInvoiceItem",
      "through": null
    },
    {
      "className": "StripeInvoice",
      "collectionName": "stripe_invoices",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_invoices",
      "macro": "has_many",
      "resource_name": "StripeInvoice",
      "through": null
    },
    {
      "className": "StripeOrder",
      "collectionName": null,
      "foreignKey": "stripe_customer_id",
      "name": "stripe_orders",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripePaymentIntent",
      "collectionName": "stripe_payment_intents",
      "foreignKey": "customer",
      "name": "stripe_payment_intents",
      "macro": "has_many",
      "resource_name": "StripePaymentIntent",
      "through": null
    },
    {
      "className": "StripePaymentMethod",
      "collectionName": "stripe_payment_methods",
      "foreignKey": "customer",
      "name": "stripe_payment_methods",
      "macro": "has_many",
      "resource_name": "StripePaymentMethod",
      "through": null
    },
    {
      "className": "StripeSetupIntent",
      "collectionName": null,
      "foreignKey": "customer",
      "name": "stripe_setup_intents",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripeSubscriptionSchedule",
      "collectionName": null,
      "foreignKey": "stripe_customer_id",
      "name": "stripe_subscription_schedules",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_subscriptions",
      "macro": "has_many",
      "resource_name": "StripeSubscription",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "balance",
      "column": {
        "default": null,
        "name": "balance",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "business_vat_id",
      "column": {
        "default": null,
        "name": "business_vat_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "default_source",
      "column": {
        "default": null,
        "name": "default_source",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "delinquent",
      "column": {
        "default": null,
        "name": "delinquent",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "discount",
      "column": {
        "default": null,
        "name": "discount",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "shipping",
      "column": {
        "default": null,
        "name": "shipping",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "stripe_customer_id",
      "name": "account",
      "macro": "has_one",
      "resource_name": "Account",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_subscriptions",
      "macro": "has_many",
      "resource_name": "StripeSubscription",
      "through": null
    }
  ],
  "paramKey": "stripe_customer",
  "primaryKey": "id"
}

/** Frontend model for StripeCustomer. */
export default class StripeCustomer extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  currency() {
    return this.readAttributeUnderscore("currency")
  }

  /** @returns {boolean} */
  hasCurrency() {
    const value = this.currency()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }

  /** @returns {import("./account.js").default | null} */
  account() {
    return this._readHasOneReflection({modelClass: Account, reflectionName: "account"})
  }

  /** @returns {Promise<import("./account.js").default | null>} */
  loadAccount() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["stripe_customer_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "account",
        model: this,
        modelClass: Account
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./account.js").default | null>} */
  ensureAccountLoaded() {
    return this.ensureAssociationLoaded("account")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./stripe-subscription.js").default>} */
  stripeSubscriptions() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const ransack = {}

    ransack["stripe_customer_id_eq"] = this.stripeId()

    return new Collection(
      {
        reflectionName: "stripe_subscriptions",
        model: this,
        modelClass: StripeSubscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-subscription.js").default>>} */
  loadStripeSubscriptions() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const ransack = {}

    ransack["stripe_customer_id_eq"] = this.stripeId()

    return this._loadHasManyReflection(
      {
        reflectionName: "stripe_subscriptions",
        model: this,
        modelClass: StripeSubscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-subscription.js").default>>} */
  ensureStripeSubscriptionsLoaded() {
    return this.ensureAssociationLoaded("stripe_subscriptions")
  }
}
